import axios from 'Src/helpers/api/axiosInstance';
import { AppUser } from 'Src/views/App/App';

export function getSchoolDashboard(user: AppUser, date?: string) {
  const { roleSessionKey: key, activeSchoolId } = user;

  const config = {
    headers: { usid: key },
    params: date ? { date } : {}
  };

  return axios.get(`${window.apiBase}/i/schools/${activeSchoolId}/dashboard`, config).then(response => {
    return response.data;
  });
}

export function updateGetStartedWizardStep(user: AppUser, step: number) {
  const { roleSessionKey: key, activeSchoolId } = user;
  const config = {
    headers: { usid: key }
  };

  const data = {
    getStartedWizardStep: step
  };

  return axios.put(`${window.apiBase}/i/schools/${activeSchoolId}`, data, config).then(response => {
    return response.data;
  });
}
